/**
 * Registry dos componentes lab.* (SPEC-ATLAS-V2 PR-2).
 *
 * Cada missionId vira `{ component, masterPanel? }`. Consumido pelo
 * registry/componentRegistry.ts via NAMESPACE_MAP em dois namespaces:
 *   - lab.form  (LAB_FORM_COMPONENTS)
 *   - lab.assess (LAB_ASSESS_COMPONENTS)
 *
 * PR-3 adiciona LAB_COLLAB_COMPONENTS (lab.collab.postits).
 */

import type { ComponentType } from 'react'

import type { MissionComponentProps } from '../../games/atlas/components'
import { ConfidenceCheck } from './ConfidenceCheck'
import { OpenQuestion } from './OpenQuestion'
import { Postits } from './Postits'
import { QuizJustified } from './QuizJustified'
import { StructuredForm } from './StructuredForm'
import { ConfidenceMasterPanel } from './panels/ConfidenceMasterPanel'
import { OpenQuestionMasterPanel } from './panels/OpenQuestionMasterPanel'
import { PostitsMasterPanel } from './panels/PostitsMasterPanel'
import { QuizJustifiedMasterPanel } from './panels/QuizJustifiedMasterPanel'
import { StructuredFormMasterPanel } from './panels/StructuredFormMasterPanel'

interface MissionRegistration {
  component: ComponentType<MissionComponentProps>
  masterPanel?: ComponentType<MissionComponentProps>
}

export const LAB_FORM_COMPONENTS: Record<string, MissionRegistration> = {
  'lab.form.openQuestion': {
    component: OpenQuestion,
    masterPanel: OpenQuestionMasterPanel,
  },
  'lab.form.structured': {
    component: StructuredForm,
    masterPanel: StructuredFormMasterPanel,
  },
}

export const LAB_ASSESS_COMPONENTS: Record<string, MissionRegistration> = {
  'lab.assess.confidence': {
    component: ConfidenceCheck,
    masterPanel: ConfidenceMasterPanel,
  },
  'lab.assess.quizJustified': {
    component: QuizJustified,
    masterPanel: QuizJustifiedMasterPanel,
  },
}

export const LAB_COLLAB_COMPONENTS: Record<string, MissionRegistration> = {
  'lab.collab.postits': {
    component: Postits,
    masterPanel: PostitsMasterPanel,
  },
}
